import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { UpdatedHeader } from 'src/easyclaim.app.components/common/UpdatedHeader';
import { VehicleFrontLeftPerspectiveImage } from 'src/easyclaim.app.screens/SInglePerspectives/VehicleFrontLeftPerspectiveImage';

import styles from './styles/MiniScreen.module.css';

interface MiniScreenProps {
	appState: AppState;
	children: ReactNode;
}

export const MiniScreen = ({ appState, children }: MiniScreenProps) => {
	return (
		<div className={styles.container}>
			{children}
			{appState.easyClaimCase?._configuration && (
				<div className={styles.screen} aria-hidden="true">
					<div className={styles.preview}>
						<div className={styles.statusBar}>
							<span>9:30</span>
							<span className={styles.notch} />
							<span>● ▰</span>
						</div>
						<UpdatedHeader
							caseId={appState.easyClaimCase.caseId}
							documentService={appState.documentService}
							currentLang={appState.appParameters.lang}
							localizedCaseUrls={appState.easyClaimCase.localizedCaseUrls}
							caseState={appState.screen}
							showLanguageSelector={false}
						/>
						<main className={styles.content}>
							<VehicleFrontLeftPerspectiveImage
								{...appState}
								vehicleImageFrontLeft={undefined}
								isPreview={true}
							/>
						</main>
						<div className={styles.footer}>
							<button className="move-next main-bottom-nav-button" disabled>
								<FormattedMessage id="button.continue" />
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
